module.exports = __webpack_public_path__ + "static/img/5.bc862c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/5.png
// module id = YAPZ
// module chunks = 0